import parse from "html-react-parser";
import { useContext } from "react";
import { SettingsContext } from "../Settings";

const ToggleSettingSection = ({
  title,
  inputName,
  helpText,
  defaultChecked,
  clearStyle,
}) => {
  const { register } = useContext(SettingsContext);

  return (
    <div
      className={`sb-tab-box clearfix ${
        clearStyle ? "sb-reset-box-style" : ""
      }`}
    >
      <div className="tab-label">
        <h3>{title}</h3>
      </div>
      <div className="sby-tab-form-field">
        <div className="sb-form-field">
          <label htmlFor={inputName} className="sby-checkbox">
            <input
              type="checkbox"
              {...register(inputName)}
              id={inputName}
              defaultChecked={defaultChecked}
            />
            <span className="toggle-track">
              <div className="toggle-indicator"></div>
            </span>
          </label>
          {helpText && <span className="help-text">{parse(helpText)}</span>}
        </div>
      </div>
    </div>
  );
};

export default ToggleSettingSection;
